export type MemberSeatLimitState = {
  isMemberOverLimit: boolean;
  memberSeatCap: number;
  memberSeatCapForLimitMessage: number | undefined;
};

export const getMemberSeatLimitState = ({
  isFreeTierPlan,
  isHardLimit,
  licenseType,
  planUserMax,
  seatLimit,
  seatsUsed,
  totalNewMembers,
}: {
  isFreeTierPlan?: boolean;
  isHardLimit?: boolean | null;
  licenseType?: string;
  planUserMax?: number | null;
  seatLimit?: number | null;
  seatsUsed?: number | null;
  totalNewMembers: number;
}): MemberSeatLimitState => {
  const memberSeatCap =
    isFreeTierPlan || isHardLimit
      ? seatLimit ?? Infinity
      : planUserMax ?? Infinity;
  const projectedMemberSeatsUsed = (seatsUsed ?? 0) + totalNewMembers;

  const isMemberOverLimit =
    licenseType === 'MEMBER' &&
    totalNewMembers > 0 &&
    projectedMemberSeatsUsed > memberSeatCap;

  const memberSeatCapForLimitMessage =
    isMemberOverLimit && Number.isFinite(memberSeatCap)
      ? memberSeatCap
      : undefined;

  return { isMemberOverLimit, memberSeatCap, memberSeatCapForLimitMessage };
};
